(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-news"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.news-article-page__body .reveal').forEach((element) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(element);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-news"]) return;
  try {
    
  document.querySelectorAll('[data-cate-wrap]').forEach((wrap) => {
    const toggle = wrap.querySelector('[data-cate-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      wrap.classList.toggle('open');
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) {
        wrap.classList.remove('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-collections"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-slider]').forEach((section) => {
    const viewport = section.querySelector('[data-slider-viewport]');
    const track = section.querySelector('[data-slider-track]');
    const slides = section.querySelectorAll('.slider-slide');
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');
    const dotsWrap = section.querySelector('[data-slider-dots]');

    if (!viewport || !track || slides.length === 0) return;

    let currentIndex = 0;
    const count = slides.length;

    const getSlidesToShow = () => {
      const vw = window.innerWidth;
      if (vw <= 480) return 1;
      if (vw <= 768) return 2;
      if (vw <= 1199) return 3;
      return 4;
    };

    const updateDimensions = () => {
      const slidesToShow = getSlidesToShow();
      section.style.setProperty('--slides-to-show', slidesToShow);
      return slidesToShow;
    };

    const updateDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `slider-dot ${i === currentIndex ? 'is-active' : ''}`;
        btn.setAttribute('aria-label', `Slide ${i + 1}`);
        const dot = document.createElement('span');
        dot.className = 'slider-dot-inner';
        btn.appendChild(dot);
        btn.addEventListener('click', () => goTo(i));
        li.appendChild(btn);
        dotsWrap.appendChild(li);
      }
    };

    const goTo = (index) => {
      const slidesToShow = updateDimensions();
      const maxIndex = Math.max(0, count - slidesToShow);

      if (index < 0) {
        index = maxIndex;
      } else if (index > maxIndex) {
        index = 0;
      }
      currentIndex = index;

      const slidePercentage = 100 / slidesToShow;
      const offset = -(currentIndex * slidePercentage);

      track.style.transform = `translateX(${offset}%)`;

      if (dotsWrap) {
        const dots = dotsWrap.querySelectorAll('.slider-dot');
        dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === currentIndex);
        });
      }
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
    }

    // Touch / swipe support
    let startX = 0;
    let currentX = 0;
    let isTouching = false;

    viewport.addEventListener(
      'touchstart',
      (e) => {
        startX = e.touches[0].clientX;
        currentX = startX;
        isTouching = true;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      (e) => {
        if (!isTouching) return;
        currentX = e.touches[0].clientX;
      },
      { passive: true }
    );

    viewport.addEventListener('touchend', () => {
      if (!isTouching) return;
      isTouching = false;
      const diff = startX - currentX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      }
    });

    window.addEventListener('resize', () => {
      updateDimensions();
      goTo(currentIndex);
    });

    updateDimensions();
    updateDots();
    goTo(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-stories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-article-tabs]').forEach((section) => {
    // 1. Tab Switching
    const tabLinks = section.querySelectorAll('[data-tab-target]');
    const tabPanels = section.querySelectorAll('[data-tab-panel]');

    const initSlider = (container) => {
      const viewport = container.querySelector('[data-slider-viewport]');
      const track = container.querySelector('[data-slider-track]');
      const slides = container.querySelectorAll('.slider-slide');
      const prevBtn = container.querySelector('[data-slider-prev]');
      const nextBtn = container.querySelector('[data-slider-next]');
      const dotsWrap = container.querySelector('[data-slider-dots]');

      if (!viewport || !track || slides.length === 0) return;

      let currentIndex = 0;
      const count = slides.length;

      // Generate dots
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (let i = 0; i < count; i++) {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = `slider-dot ${i === 0 ? 'is-active' : ''}`;
          btn.setAttribute('aria-label', `Slide ${i + 1}`);
          const dot = document.createElement('span');
          dot.className = 'slider-dot-inner';
          btn.appendChild(dot);
          btn.addEventListener('click', () => goTo(i));
          li.appendChild(btn);
          dotsWrap.appendChild(li);
        }
      }

      const updateSlideWidth = () => {
        const vw = window.innerWidth;
        let w;
        if (vw <= 640) {
          w = Math.floor(vw * 0.9);
        } else if (vw <= 1199) {
          w = Math.min(Math.floor(vw * 0.8), 640);
        } else {
          w = Math.min(Math.floor(vw * 0.58), 920);
        }
        container.style.setProperty('--slide-width', `${w}px`);
        return w;
      };

      const goTo = (index) => {
        if (index < 0) index = count - 1;
        if (index >= count) index = 0;
        currentIndex = index;

        const slideWidth = updateSlideWidth();
        const viewportWidth = viewport.clientWidth;
        const gap = 0; // slide width includes padding
        const offset = (viewportWidth - slideWidth) / 2 - currentIndex * slideWidth;

        track.style.transform = `translateX(${offset}px)`;

        slides.forEach((slide, idx) => {
          slide.classList.toggle('is-active', idx === currentIndex);
        });

        if (dotsWrap) {
          const dots = dotsWrap.querySelectorAll('.slider-dot');
          dots.forEach((dot, idx) => {
            dot.classList.toggle('is-active', idx === currentIndex);
          });
        }
      };

      // Click on slides to select
      slides.forEach((slide, idx) => {
        slide.addEventListener('click', (e) => {
          if (idx !== currentIndex) {
            e.preventDefault();
            goTo(idx);
          }
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
      }

      // Touch / swipe support
      let startX = 0;
      let currentX = 0;
      let isTouching = false;

      viewport.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          currentX = startX;
          isTouching = true;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        (e) => {
          if (!isTouching) return;
          currentX = e.touches[0].clientX;
        },
        { passive: true }
      );

      viewport.addEventListener('touchend', () => {
        if (!isTouching) return;
        isTouching = false;
        const diff = startX - currentX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            goTo(currentIndex + 1);
          } else {
            goTo(currentIndex - 1);
          }
        }
      });

      window.addEventListener('resize', () => {
        goTo(currentIndex);
      });

      goTo(0);
      container._goTo = goTo;
    };

    // Initialize all sliders in panels
    const sliderContainers = section.querySelectorAll('[data-center-slider]');
    sliderContainers.forEach((container) => {
      initSlider(container);
    });

    // Handle tab clicks
    tabLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = link.getAttribute('data-tab-target');

        tabLinks.forEach((l) => {
          const isActive = l === link;
          l.classList.toggle('current', isActive);
          l.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        tabPanels.forEach((panel) => {
          const isTarget = panel.getAttribute('data-tab-panel') === target;
          panel.classList.toggle('is-active', isTarget);
          if (isTarget) {
            const container = panel.querySelector('[data-center-slider]');
            if (container && container._goTo) {
              container._goTo(0);
            }
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["encyclopedia-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.encyclopedia-article__body .reveal').forEach((element) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(element);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-buttons"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-floating-buttons]');
    if (!root) return;
    var topBtn = root.querySelector('[data-back-to-top]');
    if (!topBtn) return;
    function onScroll() {
      if (window.scrollY > 500) {
        topBtn.classList.add('is-visible');
      } else {
        topBtn.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["government-subsidy"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gov-subsidy]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-gov-tab]');
    const panes = section.querySelectorAll('[data-gov-pane]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.govTab;

        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panes.forEach((pane) => {
          const active = pane.dataset.govPane === target;
          pane.classList.toggle('is-active', active);
          if (active) {
            pane.removeAttribute('hidden');
          } else {
            pane.setAttribute('hidden', '');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.site-header');
  if (header) {
    const setHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
  }

  const localeSelects = document.querySelectorAll('[data-locale-select]');
  localeSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      if (this.form) {
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-banner]').forEach((banner) => {
    const track = banner.querySelector('[data-home-banner-track]');
    const slides = banner.querySelectorAll('[data-home-banner-slide]');
    const dots = banner.querySelectorAll('[data-home-banner-dot]');
    const prev = banner.querySelector('[data-home-banner-prev]');
    const next = banner.querySelector('[data-home-banner-next]');
    const autoplay = banner.dataset.autoplay === 'true';
    const speed = parseInt(banner.dataset.autoplaySpeed, 10) || 5000;

    if (!track || slides.length <= 1) {
      return;
    }

    let index = 0;
    let timer = null;

    const setSlide = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * (100 / slides.length)}%)`;

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.querySelectorAll('.home-banner__image, .home-banner__picture img').forEach((img) => {
          img.classList.toggle('is-zoomed', active);
        });
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const stopAutoplay = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!autoplay) {
        return;
      }
      timer = window.setInterval(() => {
        setSlide(index + 1);
      }, speed);
    };

    prev?.addEventListener('click', () => {
      setSlide(index - 1);
      startAutoplay();
    });

    next?.addEventListener('click', () => {
      setSlide(index + 1);
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setSlide(parseInt(dot.dataset.homeBannerDot, 10));
        startAutoplay();
      });
    });

    banner.addEventListener('mouseenter', stopAutoplay);
    banner.addEventListener('mouseleave', startAutoplay);
    banner.addEventListener('focusin', stopAutoplay);
    banner.addEventListener('focusout', startAutoplay);

    setSlide(0);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-ticker"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-news-slider]').forEach((section) => {
    const viewport = section.querySelector('[data-news-slider-viewport]');
    const track = section.querySelector('[data-news-slider-track]');
    const prev = section.querySelector('[data-news-slider-prev]');
    const next = section.querySelector('[data-news-slider-next]');

    if (!viewport || !track) {
      return;
    }

    const updateCardWidths = () => {
      const viewportWidth = viewport.clientWidth;
      let cols = 3;
      if (window.innerWidth <= 480) {
        cols = 1;
      } else if (window.innerWidth <= 991) {
        cols = 2;
      }
      const gap = 30; // 1.875rem
      const cardWidth = Math.floor((viewportWidth - gap * (cols - 1)) / cols);
      section.style.setProperty('--card-width', `${cardWidth}px`);
    };

    updateCardWidths();
    window.addEventListener('resize', updateCardWidths);

    const scrollStep = () => {
      const card = track.querySelector('.news-slider__card');
      if (!card) {
        return viewport.clientWidth * 0.8;
      }
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    if (prev) {
      prev.addEventListener('click', () => {
        viewport.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        viewport.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('#product-page').forEach((page) => {
    // Thumbnail selection
    const mediaItems = page.querySelectorAll('[data-product-media]');
    const thumbs = page.querySelectorAll('[data-product-thumb]');

    const showMedia = (index) => {
      mediaItems.forEach((item, i) => item.classList.toggle('is-active', i === index));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(parseInt(thumb.dataset.productThumb, 10)));
    });

    // Lightbox
    const lightbox = page.querySelector('[data-product-lightbox]');
    const lightboxBody = page.querySelector('[data-product-lightbox-body]');

    if (lightbox && lightboxBody) {
      page.querySelectorAll('[data-product-zoom]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const img = btn.querySelector('img');
          if (!img) return;
          lightboxBody.replaceChildren(img.cloneNode(true));
          if (typeof lightbox.showModal === 'function') {
            lightbox.showModal();
          } else {
            lightbox.setAttribute('open', '');
          }
        });
      });

      const closeLightbox = () => {
        if (typeof lightbox.close === 'function') {
          lightbox.close();
        } else {
          lightbox.removeAttribute('open');
        }
      };

      page.querySelector('[data-product-lightbox-close]')?.addEventListener('click', closeLightbox);
      // Click the backdrop, or press Escape, to dismiss.
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });
      lightbox.addEventListener('cancel', (e) => {
        e.preventDefault();
        closeLightbox();
      });
    }

    // Quantity stepper; the number input stays the single source of truth.
    const qtyInput = page.querySelector('[data-product-qty]');
    if (qtyInput) {
      const stepQty = (delta) => {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      };
      page.querySelector('[data-product-qty-down]')?.addEventListener('click', () => stepQty(-1));
      page.querySelector('[data-product-qty-up]')?.addEventListener('click', () => stepQty(1));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-store-locator]').forEach((section) => {
    const form = section.querySelector('[data-store-filter-form]');
    const select = section.querySelector('[data-store-city-filter]');
    const cards = section.querySelectorAll('[data-store-card]');
    const empty = section.querySelector('[data-store-empty]');

    if (!form || !select || cards.length === 0) {
      return;
    }

    const applyFilter = () => {
      const city = select.value;
      let visible = 0;

      cards.forEach((card) => {
        const match = city === '' || card.dataset.city === city;
        card.hidden = !match;
        if (match) {
          visible += 1;
        }
      });

      if (empty) {
        empty.hidden = visible > 0;
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      applyFilter();
    });

    select.addEventListener('change', applyFilter);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.stories-article__body .reveal').forEach((element) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(element);
  });

  } catch(e) { console.error(e); }
})();
})();
